module.exports = {"421071001":"联合街道","421071002":"西湖街道","421071100":"滩桥镇","421071400":"沙市农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421071.json
// module id = 1768
// module chunks = 0